import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
import { TFormDataEmpresa, TUserIdentityRepresentantes } from "../components/ConvenienceTest/ConvenienceTestScreenAccountCompanyHolderData/types/EmpresaTypes";

setupInterceptorsTo(axios);

class CompaniesService {
    public addCompanies = async (companiesData: TFormDataEmpresa): Promise<number> => {
        let url: string = `${proxyUrl}/companies/addCompanies`;
        const req = await axios.post<number>(url, companiesData, { headers: { "content-type": "application/json" } });
        return req.data;
    };

    public GetUserIdentitiesRepresentantesInfoByUserId = async (userId: string): Promise<TUserIdentityRepresentantes[]> => {
        let url: string = `${proxyUrl}/companies/GetUserIdentitiesRepresentantesInfoByUserId/${userId}`;
        const req = await axios.get<TUserIdentityRepresentantes[]>(url);
        return req.data;
    };
};

const companiesService = new CompaniesService();
export default companiesService;